import { ProvisioningEnum } from '../../types';

/**
 * Get the provisioning related to a squiggly
 * @category Getters
 * @category Squiggly
 */
export const getSquigglyProvisioning = (id: string) => {
  switch (id.replace(/{|}/g, '')) {
    case 'system.url.chatUrl':
      return ProvisioningEnum.Chat;
    case 'system.url.insuranceUrl':
      return ProvisioningEnum.Insurance;
    case 'patientBalance':
    case 'patientUsdBalance':
      return ProvisioningEnum.LumaPay;
    default:
      return undefined;
  }
};
